module.exports = __webpack_public_path__ + "img/FR_workerInfo_editBankAccount.e852db87.png";